import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGift = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Vector",
		d: "M28 15V26C28 26.5304 27.7893 27.0391 27.4142 27.4142C27.0391 27.7893 26.5304 28 26 28H7C6.46957 28 5.96086 27.7893 5.58579 27.4142C5.21071 27.0391 5 26.5304 5 26V15M16 6.5C16 5.80777 15.7947 5.13108 15.4101 4.55551C15.0256 3.97993 14.4789 3.53133 13.8394 3.26642C13.1999 3.00152 12.4961 2.9322 11.8172 3.06725C11.1383 3.2023 10.5146 3.53564 10.0251 4.02513C9.53564 4.51461 9.2023 5.13825 9.06725 5.81719C8.9322 6.49612 9.00152 7.19985 9.26642 7.83939C9.53133 8.47893 9.97993 9.02556 10.5555 9.41014C11.1311 9.79473 11.8078 10 12.5 10H16M16 6.5V10M16 6.5C16 5.80777 16.2053 5.13108 16.5899 4.55551C16.9744 3.97993 17.5211 3.53133 18.1606 3.26642C18.8001 3.00152 19.5039 2.9322 20.1828 3.06725C20.8617 3.2023 21.4854 3.53564 21.9749 4.02513C22.4644 4.51461 22.7977 5.13825 22.9328 5.81719C23.0678 6.49612 22.9985 7.19985 22.7336 7.83939C22.4687 8.47893 22.0201 9.02556 21.4445 9.41014C20.8689 9.79473 20.1922 10 19.5 10H16M16 10V28M4.5 15H28.5C29.328 15 30 14.328 30 13.5V11.5C30 10.672 29.328 10 28.5 10H4.5C3.672 10 3 10.672 3 11.5V13.5C3 14.328 3.672 15 4.5 15Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgGift;
